import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, PRIMARY_OUTLET, Params } from '@angular/router';
import { CoreRoutingModule } from 'app/core/core-routing.module';
import { routes } from 'app/app-routing.module';

interface IBreadcrumb {
    label: string;
    params?: Params;
    url: string;
}

@Component({
    selector: 'itpx-breadcrumbs',
    template: `
    <ol class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs; let last = last">
        <a *ngIf="!last" [routerLink]="[breadcrumb.url, breadcrumb.params]">{{ breadcrumb.label }}</a>
        <span *ngIf="last">{{ breadcrumb.label }}</span>
    </li>
</ol>
`,
    styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {

    public breadcrumbs: IBreadcrumb[];

    constructor(
        // private cdr: ChangeDetectorRef,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {
        this.breadcrumbs = [];
    }

    ngOnInit() {
        const ROUTE_DATA_BREADCRUMB: string = 'breadcrumb';

        //subscribe to the NavigationEnd event
        //   this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {

        //set breadcrumbs
        let root: ActivatedRoute = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
        // this.cdr.detectChanges();
        //   });

    }

    private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
        const ROUTE_DATA_BREADCRUMB: string = 'breadcrumb';

        //get the child routes
        let children: ActivatedRoute[] = route.children;

        //return if there are no more children
        if (children.length === 0) {
            return breadcrumbs;
        }

        //iterate over each children
        for (let child of children) {
            //verify primary route
            if (child.outlet !== PRIMARY_OUTLET) {
                continue;
            }

            //verify the custom data property "breadcrumb" is specified on the route
            if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
                return this.getBreadcrumbs(child, url, breadcrumbs);
            }

            //get the route's URL segment
            let routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

            //append route URL to URL
            url += `/${routeURL}`;

            //add breadcrumb
            let breadcrumb: IBreadcrumb = {
                label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
                params: child.snapshot.params,
                url: url
            };
            if (routeURL)
                breadcrumbs.push(breadcrumb);

            //recursive
            return this.getBreadcrumbs(child, url, breadcrumbs);
        }

        //we should never get here, but just in case
        return breadcrumbs;
    }

    public goBack() {
        let root: ActivatedRoute = this.activatedRoute.root;
        this.breadcrumbs = this.getBreadcrumbs(root);
        if (this.breadcrumbs.length > 1)
            this.router.navigate([this.breadcrumbs[this.breadcrumbs.length - 2].url], [this.breadcrumbs[this.breadcrumbs.length - 2].params]);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/breadcrumbs/breadcrumbs.component.ts